import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Content, Sidebar, Footer, Header } from "./index";

const Layout: React.FunctionComponent<RouteComponentProps> = () => {
  return (
    <div className="c-app c-default-layout">
      <Sidebar />
      <div className="c-wrapper">
        <Header />
        <div className="c-body">
          <Content />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
